interface Theme {
  backgroundColor: string;
  primaryColor: string;
  textColor: string;
  secondaryColor: string;
  tertiaryColor: string;
  quaternaryColor: string;
  neutralColor: string;
  borderColor: string;
}

/** Global choice for elements with backgrounds: rounded (uniform --radius) or sharp (no radius). */
export type ShapeMode = "rounded" | "sharp";

/** Applied to document root as data-shape. Default "rounded"; "sharp" zeros radius app-wide. */
export const SHAPE_UI: ShapeMode = "rounded";

/** Prototype-console-v1 base palette; FI settings API overrides per institution. */
export const defaultTheme: Theme = {
  backgroundColor: "#11466B",
  primaryColor: "#1F497E",
  textColor: "#0D2033",
  secondaryColor: "#0D98C7",
  tertiaryColor: "#F0F4F7",
  quaternaryColor: "#4A87A8",
  neutralColor: "#FFFFFF",
  borderColor: "#C8DCE8",
};
